import type { ReactNode } from 'react'
import { cn } from '@/components/ui'

/**
 * Le titre de la DA 2027 : Outfit 900 serré, et **un seul mot** en Playfair
 * italique — `accent`, le plus souvent le dernier, point final compris.
 *
 *     <Titre as="h2" accent="maintenant.">À faire</Titre>
 *
 * ⚠️ **Majuscule en début de phrase** (décision de Baptiste, 2026-10-27) : la
 * charte écrite dit minuscules, l'Oasis ne la suit pas sur ce point.
 *
 * La taille est donnée par l'appelant (`className`) : un titre de section prend
 * `text-(length:--t-section)` — voir `TitreSection` —, un héros la sienne.
 */
export function Titre({
  as: Balise = 'h2',
  accent,
  children,
  className,
}: {
  as?: 'h1' | 'h2' | 'h3' | 'p'
  /** Le mot en Playfair italique, avec sa ponctuation. */
  accent?: string
  children: ReactNode
  className?: string
}) {
  return (
    <Balise className={cn('u-t27 text-ink', className)}>
      {children}
      {accent && (
        <>
          {' '}
          <span className="u-accent">{accent}</span>
        </>
      )}
    </Balise>
  )
}

/** La légende : monospace, capitales, espacée — le surtitre des blocs. */
export function Legende({ children, className }: { children: ReactNode; className?: string }) {
  return <span className={cn('u-legende block text-ink-soft', className)}>{children}</span>
}
